// React Lib
import React from "react";
// Component Styles
import { useStyles } from "./UserRoleStyles";
// @otg-one/ui_components/components
import { Button, Typography } from "../index";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
// Utils
import { formatNumericalWithThousandSeparator } from "../../utils/Utils";
export const UserRole = (props) => {
    const classes = useStyles(props);
    const { id, userRoleCount, onClick, style, textUserRoles, textRolesConfigured, textSeeAll } = props;
    return (React.createElement("div", { className: classes.userRoleContainer, style: style, id: id },
        React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_MEDIUM, size: 16, color: Color.neutral[100] }, textUserRoles),
        React.createElement("div", { className: classes.userRoleBox },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, size: 56, color: Color.neutral[0] }, formatNumericalWithThousandSeparator(userRoleCount)),
            React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_ITALIC, size: 12, color: Color.neutral[0] }, textRolesConfigured)),
        React.createElement(Button, { type: "secondary", color: "white", style: { marginTop: 40 }, onClick: onClick }, textSeeAll)));
};
UserRole.defaultProps = {
    userRoleCount: 5,
    onClick: () => { },
    textUserRoles: 'User Roles',
    textRolesConfigured: 'Roles Configured',
    textSeeAll: 'See All'
};
export default React.memo(UserRole);
